<template>
  <div class="ds-control dsf_teas_class_album_list mobile">
    <div class="class_album_list">
      <div class="album_item">
        <div class="album_img"  @click="toAlbumIndex()">
          <i class="iconfont icon-charutupian"></i>
          <span>新建相册</span>
        </div>
        <div class="album_info_zw"></div>
      </div>
      <div class="album_item" v-for="(item,index) of albumList" :key="index">
        <div class="album_img_box" @click="toDetails(item)">
          <van-image :src="item.coverPhoto | imgFormat" width="100%" height="100%" fit="cover" radius="4">
            <template v-slot:error>
              <img :src="require('../../assets/styles/themes/img/img-nopicture.png')" alt="" class="err_img">
              <!-- <div class="err_box"></div> -->
            </template>
          </van-image>
          <!-- <div class="album_num">
            <i class="iconfont icon-tupian"></i>
            <span>{{item.photoNum || 0}}</span>
          </div> -->
          <!-- <div v-if="mantleShow == index && (item.editPermissions || item.delPermissions)" class="album_item_mantle" @click.stop="mantleShow=null">
            <div class="mantle_btn_edit mantle_btn" @click.stop="toAlbumIndex(item)" v-if="item.editPermissions">编辑</div>
            <div class="mantle_btn_delte mantle_btn" @click.stop="delteBtn(item)" v-if="item.delPermissions">删除</div>
          </div> -->
        </div>
        <div class="album_info">
          <div class="album_title">
            <div>{{item.albumName}}</div>
            <span @click="toAlbumIndex(item)">编辑</span>
          </div>
          <div class="album_info_num">
            <div>{{item.photoNum || 0}}张</div>
            <span>{{item.dsCreateUserName}}创建</span>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasClassAlbumList",
  ctrlCaption: "移动班级相册列表",
  mixins: [$mixins.layout],
  design: {
    isMask: false,
  },
  props: {
    // 创建相册Url
    createdAlbumUrl: {
      type: String,
      default: "/mobile/teas/classes/album/mobile_album/mobile-edit",
    },
    // 编辑相册Url
    editAlbumUrl: {
      type: String,
      default: "/mobile/teas/classes/album/mobile_album/mobile-edit",
    },
    confirmTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mantleShow: null,
      loop: "",
      albumList: []
    }
  },
  created() {

  },
  mounted() {
    if (this.isDesign) {
      this.albumList = [{
        albumName: "相册1",
        coverPhoto: "https://img0.baidu.com/it/u=2900085125,3367214430&fm=15&fmt=auto",
        delPermissions: true,
        description: "相册相册",
        dsCreateTime: "2021-10-08",
        dsCreateUserId: "f80ce69fdb62454698228706a0777130",
        dsCreateUserName: "付雪梅",
        editPermissions: true,
        id: "1704d667118b4e0bb1bcf4a57e37a152",
        photoNum: null
      }]
    } else {
      this.getData()
    }
  },
  activated() {
    this.getData();
  },
  methods: {
    toDetails(item) {
      let classId = this.queryString.classId || '';
      this.$open({
        title: item.albumName,
        url: "#/mobile/teas/classes/album/mobile_album/mobile-album_details" + '?id=' + item.id + "&classId=" + classId + "&coverPhoto=" + item.coverPhoto,
        state: 1,
      });
    },
    getData() {
      let loading = dsf.layer.loading();
      let id = this.queryString.classId || dsf.getCookie('class_id') || '';
      let data = {
        classId: id,
        keyword: ""
      }
      this.$http.get('/mobile/teas/album/getClassAlbumList', data).done((res) => {
        if (res.success && res.state == 20000) {
          this.albumList = res.data;
        } else {
          dsf.layer.message(res.message, false);
        }
      }).error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });

    },
    // 创建相册
    toAlbumIndex(item) {
      if(this.isDesign) return
      let classId = this.queryString.classId || dsf.getCookie('class_id') || '';
      if (item) {
        this.$router.push({
          path: this.editAlbumUrl + '?id=' + item.id + '&classId=' + classId,
        });
      } else {
        this.$router.push({
          path: this.createdAlbumUrl + '?classId=' + classId,
        });
      }
    },
    // 删除相册   
    // delteBtn(item) {
    //   let _this = this;
    //   if (this.$listeners["delete-album"]) {
    //     this.$dispatch("delete-album", item);
    //   } else {
    //     let content = this.confirmTitle || `删除"${item.albumName}"后不可恢复， 确认删除？`
    //     let that = this;
    //     dsf.layer
    //       .confirm(content)
    //       .then((res) => {
    //         that.deleteDataVal(item);
    //         this.mantleShow = null;
    //       }).catch((err) => {
    //       });
    //   }
    // },
    // deleteDataVal(ite) {
    //   let loading = dsf.layer.loading();
    //   this.$http
    //     .post(
    //       "/mobile/teas/album/delAlbum",
    //       { albumId: ite.id },
    //     ).done((res) => {
    //       if (res.success && res.state == 20000) {
    //         dsf.layer.message(res.message, true);
    //         this.$emit('change')
    //         this.getData();
    //       } else {
    //         dsf.layer.message(res.message, false);
    //       }
    //     }).error((err) => {
    //       dsf.layer.message(err.message || "出错了，请重试", false);
    //     })
    //     .always(() => {
    //       dsf.layer.closeLoading(loading);
    //     });
    // },
    reloadData() {
      this.getData()
      _.each(this.$children, (child) => {
        child?.reloadData && child.reloadData();
      });
    },
  }
})
</script>

<style>
</style>